/**
 * stopEvent controller mixin
 */

/**
 * stopEventCtrlMixinFactory
 * returns stopEventCtrlMixin mixin factory
 *
 * @class stopEventCtrlMixinFactory
 * @memberof mwApp/common
 * @see mwApp/common
 *
 * @ngdoc factory
 * @name mwApp/common.factory:stopEventCtrlMixinFactory
 */
/* @ngInject */
export default function stopEventCtrlMixinFactory ($location) {
  /**
   * Mixin with stopEvent controller method
   *
   * @mixin stopEventCtrlMixin
   * @memberof mwApp/common
   * @see mwApp/common
   * @name mwApp/common.mixin:stopEventCtrlMixin
   *
   * @type {Object}
   */
  return {

    // stop propogation and default action for event
    stopEvent: function ($event) {
      if ($event) {
        $event.stopPropagation()
        $event.preventDefault()
      }
    },

    // stop propagation and default action for event
    stopPropagation: function ($event) {
      if ($event) {
        $event.stopPropagation()
      }
    },

    // stop propogation and default action for event, and then go to a.href
    stopEventAndGo: function ($event) {
      this.stopEvent($event)
      var link = $event ? $event.currentTarget : null
      var href = link ? link.getAttribute('href') : null
      if (href) {
        $location.url(href)
      }
    }
  }
}
